// extracted by mini-css-extract-plugin
export default {"box":"FooterLinks_box__4EtRq","linksList":"FooterLinks_linksList__VmMNB","link":"FooterLinks_link__HdXc5"};